import {
  ParametricAssetId,
  SubmittingOrganization,
  type ParametricAsset,
} from "@/types";
type AssetParams = {
  L: number; // Longueur
  l: number; // Largeur
  b: number; // Biais
};

const asset: ParametricAsset<AssetParams> = {
  id: ParametricAssetId.SLAB_BRIDGE_INTRADOS,
  image: "/images/assets/pont-dalle-intrados.png",
  submittedBy: SubmittingOrganization.ARS,
  inputs: [
    {
      key: "L",
      type: "dimension",
    },
    {
      key: "l",
      type: "dimension",
    },
    {
      key: "b",
      type: "angle",
    },
  ],
  build: (params, offset) => {
    const { L, l, b } = params;
    const bRad = (b * Math.PI) / 180;
    return [
      {
        // center parallelogram
        type: "polyline",
        points: [
          [
            // bottom Left
            offset[0] - l / 2 + (Math.sin(bRad) * L) / 2,
            offset[1] - (L / 2) * Math.cos(bRad),
            offset[2],
          ],
          [
            // bottom right
            offset[0] + l / 2 + (Math.sin(bRad) * L) / 2,
            offset[1] - (L / 2) * Math.cos(bRad),
            offset[2],
          ],
          [
            // top right
            offset[0] + l / 2 - (Math.sin(bRad) * L) / 2,
            offset[1] + (L / 2) * Math.cos(bRad),
            offset[2],
          ],
          [
            // top left
            offset[0] - l / 2 - (Math.sin(bRad) * L) / 2,
            offset[1] + (L / 2) * Math.cos(bRad),
            offset[2],
          ],
          [
            // bottom Left
            offset[0] - l / 2 + (Math.sin(bRad) * L) / 2,
            offset[1] - (L / 2) * Math.cos(bRad),
            offset[2],
          ],
        ],
      },
    ];
  },
};

export default asset;
